import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

export const StyledWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
}));

export const StyledImageSkeleton = styled(Skeleton)(({ theme }) => ({
    width: "100%",
    paddingBottom: "56%",
    marginBottom: theme.spacing(2),
    borderRadius: theme.kaltura.shape.roundness2,
}));

export const StyledTitleSkeleton = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(1.5),
    borderRadius: "2px",
    width: "80%",
    height: 24,
}));

export const StyledStatsWrapperSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export const StyledStatsSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: "2px",
    width: "31%",
    height: 16,
}));

export const StyledActionsSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    width: "30%",
    height: 32,
}));
